export interface LibConfig {
  isProd: boolean;
  passengerApiUrl?: string;
  remoteConfigUrl?: string;
  driverApiUrl?: string;
  boApiUrl?: string;
  storagePrefix: string | null;
  systemLocale: string | null;
  forceLocale?: string | null;
  preludeApiKey?: string;
  reloadSystem: () => void;
  googleClientIdIos?: string;
  googleWebClientId?: string;
  openWebUrl?: (url: string) => void;
  storage: {
    setItem: (_key: string, _value: string) => void;
    getItem: (_key: string) => string | null | undefined;
    removeItem: (_key: string) => void;
  };
}

let _config: LibConfig | null = null;

export const initSharedLib = (config: LibConfig) => {
  _config = config;
};

export const getConfig = (): LibConfig => {
  if (!_config) {
    throw new Error('Shared library non initialisée. Appelez initSharedLib() au démarrage.');
  }
  return _config;
};
